import React from "react";
import NotificationPanel from "./NotificationPanel.jsx";
import "./Navbar.css";

export default function Navbar({ onToggleMobileMenu, isMobileOpen }) {
  return (
    <header className="app-navbar">
      <div className="app-navbar-left">
        <button
          type="button"
          className={`app-navbar-menu-btn ${isMobileOpen ? "is-active" : ""}`}
          onClick={onToggleMobileMenu}
          aria-label={isMobileOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isMobileOpen}
        >
          <span className="menu-bar" />
          <span className="menu-bar" />
          <span className="menu-bar" />
        </button>
        <div className="app-navbar-brand">
          <h3 className="app-navbar-title">Workspace</h3>
        </div>
      </div>
      <div className="app-navbar-right">
        <NotificationPanel />
      </div>
    </header>
  );
}